<template>
  <div class="menu-and-image d-lg-flex justify-content-lg-center align-items-lg-center mx-lg-auto px-lg-7 px-xl-0" :class="{ 'flex-lg-row-reverse menu-and-image--right-menu': positionOfMenu == 'right', 'menu-and-image--center-image': centreAlignImage }">
    <div class="menu-and-image__menu" :class="{ 'justify-content-end': positionOfMenu == 'right' && !centreAlignImage, 'justify-content-center': centreAlignImage }">
      <div>  
        <h2 class="h4 text-center text-lg-left mb-6">{{ titleText }}</h2>
        <ul class="d-none d-lg-block">
          <li v-for="(item, index) in contentJson" :key="item.id">
            <a :href="item.url" @mouseover="moveToSlide(index)" @mouseout="moveToSlide(index)" :class="{ 'active': index == activeSlide }">
              {{ item.heading_text }}
            </a>
          </li>
        </ul>
      </div>
    </div>

    <div class="menu-and-image__slider"> 
      <slick ref="main" :options="mainSlickOptions">
        <div class="slick-item-wrapper" v-for="item in contentJson" :key="item.id">
          <a v-if="!item.use_video || !item.video_show_controls" class="image-link position-relative d-block image-link--hover-effect" :href="item.url" :style="{ backgroundColor: slideBackgroundColour }">
            <div class="heading text-center d-none mb-4">
              {{ item.heading_text }}
            </div>
            <img v-if="!item.use_video && item.image" :data-lazy="item.image" :alt="item.heading_text" :class="{ 'd-none d-lg-block': item.mobile_image }">
            <img v-if="item.mobile_image || item.use_video && !item.use_video_mobile" :data-lazy="item.mobile_image" :alt="item.heading_text" class="d-lg-none">

            <div v-if="item.use_video && item.video_id" :class="[{ 'd-none d-lg-block': item.use_video_mobile && item.video_id_mobile }, item.video_aspect_ratio]">
              <iframe :src="item.video_id" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>
            </div>
            <div v-if="item.use_video && item.use_video_mobile && item.video_id_mobile" class="d-block d-lg-none" :class="item.video_aspect_ratio">
              <iframe :src="item.video_id_mobile" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>
            </div>
            <div v-if="!hideSliderTitles" class="images--headline position-absolute text-uppercase text-center">
              {{ item.heading_text }}
            </div>
          </a>
          <template v-else>
            <div v-if="item.use_video && item.video_id" :class="item.video_aspect_ratio">
              <iframe :src="item.video_id" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>
            </div>
          </template>
        </div>
      </slick>
    </div>

  </div>
</template>

<script>
/*
* Menu-and-image-slider Vue component
* ---
* Example usage:
*
* <menu-and-image-slider title-text="[HEADER ABOVE MENU TEXT]" 
*                        position-of-menu="[ left | right ]"
*                        :centre-align-image="[ true | false ]"
*                        :hide-slider-titles="[ true | false ]"
*                        :content-json='[JSON OBJECT OF DATA]' //check the quotes used in the json object you create in liquid
*                        :slide-background-colour="[CSS COLOUR VALUE]"
*                      />
*
* Notes (desktop):
*
* centre-align-image
* - true: slick slider of images placed centrally horizontally, with the menu and a gap on the other side
* - false: menu and slick slider positioned centrally horizontally (so the slick slider is off-centre)
*
* json object of data:
*  {
*    "use_video": [true | false - set to false if not in use],
*    "video_id": [full embed code],
*    "image": "[desktop image]",
*    "mobile_image": "[mobile image, can be left blank (desktop image shown at all times]",
*    "heading_text": "[text used in menu and over image]",
*    "url": "[url for use in the menu and on the image hover]"
*  }
*
* Notes (mobile):
* No menu
*/

import Slick from 'vue-slick';

export default {
    components: {
      Slick
    },

    props: [
      "titleText",
      "positionOfMenu",
      "centreAlignImage",
      "hideSliderTitles",
      "contentJson",
      "slideBackgroundColour"
    ],

    data() {
      return {  
        activeSlide: 0,
        mainSlickOptions: {
          lazyLoad: 'progressive',
          slidesToShow: 1, 
          slidesToScroll: 1, 
          arrows: false, 
          dots: false, 
          fade: true, 
          waitForAnimate: false,
          speed: 100,
          draggable: false,
          responsive: [
            { 
              breakpoint: 992, 
              settings: { 
                arrows: true,
                dots: true, 
                fade: false,
                waitForAnimate: true,
                speed: 300,
                draggable: true, 
                centerMode: true, 
                centerPadding: '50px'
              } 
            }
          ]
        }
      }
    },        

    created() {

    },

    methods: {
      moveToSlide(slideIndex) {
        this.$refs.main.goTo(slideIndex);
        this.activeSlide = slideIndex;
      }
    }
}
</script>

<style lang="scss" scoped>
 .template-product {
   @media only screen and (min-width: 992px) {
      .menu-and-image__menu {
        width: 25%;
      }
      .menu-and-image__slider {
        width: 40%;
        margin-right: 25%;
      }
    }
   
    @media only screen and (max-width: 992px) {
      .slick-item-wrapper {
        .heading {
          padding-top: 30px;
          font-size: 15px;
        }
      }
    }
  }
  
  .images--headline {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-size: 3.3vw;
    font-weight: 700;
    letter-spacing: 7.68px;
    line-height: 1.26;
    overflow: hidden;
    @media only screen and (min-width: 992px) {	
      font-size: 2.4vw;	
    }
  }
</style>
